import { ContractsStore } from "@/services/stores/types";
import { StateCreator } from "zustand";

export const contractsStore: StateCreator<ContractsStore> = set => ({
  contracts: null,
  setContracts: contracts => set(() => ({ contracts })),
});
